import {tgxApi} from "../../app/tgxApi";
import {serialize} from "../../helpers/utils/Utils";
import {getAuthorizationHeader, handleQueryError,  handleQueryErrorAndSuccess} from "../../helpers/utils/RtkQueryUtils";

export const regionApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({

        searchRegions: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/ajax/customer-regions?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['regions'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),

        getRegionById: build.query({
            query: (regionId) => {
                return {
                    url: `/ajax/customer-region-by-id/${regionId}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),

        createRegion: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/ajax/create-customer-region`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['regions'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await  handleQueryErrorAndSuccess(queryFulfilled,"Created","Region");
            },
        }),

        updateRegion: build.mutation({
            query: ({id, requestBody}) => {
                return {
                    url: `/ajax/update-customer-region-by-id/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['regions', 'regionById'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await  handleQueryErrorAndSuccess(queryFulfilled,"Updated","Region");
            },
        }),

        deleteRegionById: build.mutation({
            query: (id) => {
                return {
                    url: `/ajax/delete-region-by-id/${id}`,
                    method: 'DELETE',
                    headers: getAuthorizationHeader()
                };
            },
            invalidatesTags: ['regions'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await  handleQueryErrorAndSuccess(queryFulfilled,"Deleted","Region");
            },
        }),

        regionByCustomerId: build.query({
            query: (customerId) => {
                // Serialize the data to query parameters
                let paramData = serialize({customerId: customerId});
                return {
                    url: `/ajax/get-region-by-customer-id/${customerId}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
    })
})

export const {
    useSearchRegionsQuery,
    useGetRegionByIdQuery,
    useUpdateRegionMutation,
    useCreateRegionMutation,
    useDeleteRegionByIdMutation,
    useRegionByCustomerIdQuery,
    useLazyRegionByCustomerIdQuery
} = regionApi